import getCurrentBreakpoint from './getBreakpointValue';

export const getItemsPerBreakpoint = (
  viewportWidth: number,
  numberOfLines = 1
) => {
  const breakpoint = getCurrentBreakpoint(viewportWidth);
  return breakpoint === '3xl'
    ? 6 * numberOfLines
    : breakpoint === '2xl'
    ? 5 * numberOfLines
    : breakpoint === 'xl'
    ? 4 * numberOfLines
    : breakpoint === 'lg'
    ? 3 * numberOfLines
    : 2 * numberOfLines;
};
